import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '@app/core/auth.service';
import { faSignOut } from '@fortawesome/pro-light-svg-icons';
import { CreNgConfig } from 'cre-ng';
import { Subscription, timer } from 'rxjs';

/**
 * Component to display the idle dialog that's triggered by the {@link IdleService}.
 *
 * <example-url></example-url>
 *
 * @example
 * <cre-idle-dialog></cre-idle-dialog>
 */
@Component({
  selector: 'cre-idle-dialog',
  styleUrls: ['./idle-dialog.component.css'],
  templateUrl: './idle-dialog.component.html',
})
export class IdleDialogComponent implements OnDestroy {
  /** @ignore */
  faSignOut = faSignOut;
  /** @ignore */
  isIdleVisible: boolean;
  /** @ignore */
  time: number;
  /** @ignore */
  private counter = timer(0, 1000);
  /** @ignore */
  private loginSub: Subscription;
  /** @ignore */
  private logoutSub: Subscription;
  /** @ignore */
  private timeoutSub: Subscription;
  /** @ignore */
  private timerStartSub: Subscription;
  /** @ignore */
  private timerSub: Subscription;

  /** @ignore */
  constructor(public auth: AuthService, private config: CreNgConfig) {
    this.isIdleVisible = false;
    this.loginSub = this.auth.login$.subscribe(() => {
      this.timerStartSub = this.auth.timerStart$.subscribe((count) => {
        if (count === 1) {
          this.showIdle();
        }
      });

      this.timeoutSub = this.auth.timeout$.subscribe(() => {
        this.logout();
      });
    });

    this.logoutSub = this.auth.logout$.subscribe(() => {
      this.unsub();
    });
  }

  /** @ignore */
  logout() {
    this.unsubscribeIdleTimer();
    this.auth.logout();
    this.isIdleVisible = false;
  }

  /** @ignore */
  ngOnDestroy(): void {
    this.loginSub.unsubscribe();
    this.logoutSub.unsubscribe();
    this.timerStartSub.unsubscribe();
    this.timeoutSub.unsubscribe();
    this.unsubscribeIdleTimer();
  }

  /** @ignore */
  refreshSession() {
    this.unsubscribeIdleTimer();
    this.auth.refreshSession();
    this.isIdleVisible = false;
  }

  showIdle() {
    if (!this.isIdleVisible) {
      this.time = this.config.idleTimeout;
      this.timerSub = this.counter.subscribe(() => {
        this.updateIdleTimer();
      });
      this.isIdleVisible = true;
    }
  }

  /** @ignore */
  private unsub() {
    if (!this.timerStartSub) {
      return;
    }

    this.timerStartSub.unsubscribe();
    this.timeoutSub.unsubscribe();
    this.unsubscribeIdleTimer();
  }

  /** @ignore */
  private unsubscribeIdleTimer() {
    this.timerSub.unsubscribe();
  }

  /** @ignore */
  private updateIdleTimer() {
    this.time--;

    if (this.time === 0) {
      this.unsubscribeIdleTimer();
      this.logout();
    }
  }
}
